var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-width row justify-center",class:{'verba-root': _vm.isVerba}},[_c('div',{staticClass:"q-pa-md col-xs col-sm-8 col-md-6 col-lg-4 col-xl-3"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }